import './styles/SelectionChecker.scss';
import { AppContext } from '../Context';
import { useContext, useState, useEffect, useRef } from 'react';

//mui icons
import RadioBuuttonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';

interface Props {
    checkList: any[], //array of strings of labels ['checker 1', 'checker 2']
    checkings: boolean[], SetCheckings: any
    placeholder?: string, //default showing text in dropdown button
    uncheckableList?: string[], //array of checklabels cant be checked or unchecked
    direction?: string //up, down, left, right, default down
}

const SelectionChecker: React.FC<Props> = ({ checkList, checkings, SetCheckings, placeholder, uncheckableList, direction }) => {
    //contexts
    const appContext = useContext(AppContext);
    //state
    const [isChecking, SetIsChecking] = useState(false);
    const [dropDirection, SetDropDirection] = useState('down');
    const [allChecked, SetAllChecked] = useState(false);

    //ref
    // const selectBtnMaskRef = useRef<HTMLDivElement>(null); ---deprecated
    const selectionCheckerRef = useRef<HTMLDivElement>(null);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('checkIsChecking: ' + isChecking);
    // }, [isChecking]);

    //add mouse click listener onstart
    useEffect(() => {
        window.addEventListener('mousedown', (e: MouseEvent) => OnMouseDown(e), false);

        return (() => {
            window.removeEventListener('mousedown', (e: MouseEvent) => OnMouseDown(e), false);
        });
    }, []);

    //watch for style change
    useEffect(() => {
        if (direction != undefined)
            SetDropDirection(direction)
    }, [direction]);

    //render functions
    const RenderSelectBtn = () => {
        switch (dropDirection) {
            case 'down':
                return (
                    <button className='SelectionChecker-select-btn dropButtonStyle ' onClick={() => SetIsChecking(!isChecking)}>
                        <span className='SelectionChecker-select-btn-label'>{
                            GetCheckedCount() > 0 ?
                                GetCheckedCount() + ' ' + 'Selected'
                                :
                                placeholder
                        }</span>
                        <ArrowDropDown />
                        {/* <div className='SelectionChecker-select-btn-mask' ref={selectBtnMaskRef} /> */}
                    </button>
                );
            case 'up':
                return (
                    <button className='SelectionChecker-select-btn  dropButtonStyle ' onClick={() => SetIsChecking(!isChecking)}>
                        <span className='SelectionChecker-select-btn-label'>{
                            GetCheckedCount() > 0 ?
                                GetCheckedCount() + ' ' + 'Selected'
                                :
                                placeholder
                        }</span>
                        <ArrowDropUp />
                        {/* <div className='SelectionChecker-select-btn-mask' ref={selectBtnMaskRef} /> */}
                    </button>
                );
        }
    }
    const RenderChecker = (checklabel: string, index: number) => {
        return (
            <div className='SelectionChecker-check-row dropContentStyle ' key={'SelectionChecker-check-row-' + index}>
                <button className='SelectionChecker-check-checker' onClick={() => OnCheckerChecked(index)}>
                    {
                        checkings[index] ? <CheckCircleOutline className='SelectionChecker-check-checker-svg' /> : <RadioBuuttonUnchecked className='SelectionChecker-check-checker-svg' />
                    }
                </button>
                <span className='SelectionChecker-check-lbl'>{checklabel}</span>
                <div className={'SelectionChecker-disable-mask ' + (CheckShouldDisabled(checklabel) ? '' : 'hide')} />
            </div>
        )
    }

    //ui-function
    const OnCheckerChecked = (index: number) => {
        if (index != -1) {
            SetAllChecked(false);
            const _checkings = checkings;
            _checkings[index] = !_checkings[index];
            SetCheckings([..._checkings]);
        } else {
            SetAllChecked(!allChecked);
            CheckUncheckAllExceptUncheckable(!allChecked);
        }
    }
    const OnMouseDown = (e: MouseEvent) => {
        if(e.target != null) {
            const clickedElement = e.target as HTMLElement;
            if(
                clickedElement.parentElement != selectionCheckerRef.current &&
                clickedElement.parentElement!.parentElement != selectionCheckerRef.current &&
                clickedElement.parentElement!.parentElement!.parentElement != selectionCheckerRef.current &&
                clickedElement.parentElement!.parentElement!.parentElement!.parentElement != selectionCheckerRef.current
            ) {
               SetIsChecking(false);
            }
        }
    }

    //exe functions
    const CheckShouldDisabled = (checklabel: any) => {
        let shouldDisabled = false;
        if (uncheckableList != undefined && uncheckableList.length > 0) {
            for (let i = 0; i < uncheckableList.length; i++) {
                if (uncheckableList[i] == checklabel) {
                    shouldDisabled = true;
                    break;
                }
            }
        }
        return shouldDisabled;
    }
    const GetCheckedCount = () => {
        let checkedCount = 0;
        checkings.map((checking: boolean) => {
            if (checking) {
                checkedCount += 1;
            }
        });
        return checkedCount;
    }
    const CheckUncheckAllExceptUncheckable = (mode: boolean) => {
        const _checkings = checkings;
        checkList.map((checkLabel: string, i) => {
            let uncheckMatched = false;
            if (uncheckableList != undefined && uncheckableList.length > 0) {
                uncheckableList?.map((uncheckableLabel) => {
                    if (checkLabel == uncheckableLabel)
                        uncheckMatched = true;
                });
            }
            if (!uncheckMatched)
                _checkings[i] = mode;
        });
        SetCheckings([..._checkings]);
    }

    return (
        <div className='SelectionChecker dropStyle' ref={selectionCheckerRef}>
            {
                RenderSelectBtn()
            }
            <div className={'SelectionChecker-check-menu dropMenuStyle ' + (isChecking ? 'show' : 'hide') + ' ' + (dropDirection)}>
                {/** check all checker */}
                <div className={'SelectionChecker-check-row dropContentStyle'} key={'SelectionChecker-check-row'}>
                    <button className='SelectionChecker-check-checker' onClick={() => OnCheckerChecked(-1)} disabled={(uncheckableList != undefined && uncheckableList.length == checkList.length) ? true : false}>
                        {
                            allChecked ? <CheckCircleOutline className='SelectionChecker-check-checker-svg' /> : <RadioBuuttonUnchecked className='SelectionChecker-check-checker-svg' />
                        }
                    </button>
                    <span className='SelectionChecker-check-lbl'>Select All</span>
                </div>
                {
                    checkList.map((checklabel: string, i) => {
                        return (
                            RenderChecker(checklabel, i)
                        );
                    })
                }
            </div>
        </div>
    );
}
export default SelectionChecker;